<template>
  <svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.1924 12.1924C13.1924 12.7447 12.7447 13.1924 12.1924 13.1924H6.53557C5.98329 13.1924 5.53557 12.7447 5.53557 12.1924C5.53557 11.6401 5.98329 11.1924 6.53557 11.1924H12.1924C12.7447 11.1924 13.1924 11.6401 13.1924 12.1924Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M23.0919 12.1924C23.0919 12.5766 22.8719 12.9268 22.5257 13.0934L3.43385 22.2858C3.06443 22.4637 2.62385 22.398 2.32234 22.1201C2.02084 21.8423 1.9195 21.4085 2.06669 21.0258L5.46416 12.1924L2.06669 3.359C1.91951 2.97631 2.02084 2.54254 2.32234 2.26468C2.62385 1.98681 3.06443 1.92114 3.43385 2.09902L22.5257 11.2914C22.8719 11.4581 23.0919 11.8083 23.0919 12.1924ZM4.83885 4.99525L7.46892 11.8334C7.55779 12.0645 7.55779 12.3203 7.46892 12.5514L4.83885 19.3896L19.7868 12.1924L4.83885 4.99525Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'SendIcon',
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
    color: {
      type: String,
      default: '#99005c',
    },
  },
};
</script>
